<div class="email" tooltipPosition="bottom-right" [kdsTooltip]="email()" [disableTooltip]="!isUsernameTruncated()">
  <span #emailUsernameElement class="email__username">
    {{ emailUsername() }}
  </span>
  <span class="email__domain">{{ '@' + emailDomain() }}</span>
</div>
